<template>
  <form @submit.prevent="submitForm" class="container mt-5" novalidate>
    <div class="form-group">
      <label for="first_name">
        {{ getLabel('first_name') }}
      </label>
      <input
        type="text"
        class="form-control"
        id="first_name"
        :placeholder="getPlaceholder('first_name')"
        v-model="form.first_name"
      />
      <div v-if="form.errors.first_name" class="text-danger">
        {{ form.errors.first_name }}
      </div>
    </div>

    <div class="form-group">
      <label for="last_name">
        {{ getLabel('last_name') }}
      </label>
      <input
        type="text"
        class="form-control"
        id="last_name"
        :placeholder="getPlaceholder('last_name')"
        v-model="form.last_name"
      />
      <div v-if="form.errors.last_name" class="text-danger">
        {{ form.errors.last_name }}
      </div>
    </div>

    <div class="form-group">
      <label for="email">
        {{ getLabel('email') }}
      </label>
      <input
        type="email"
        class="form-control"
        id="email"
        :placeholder="getPlaceholder('email')"
        v-model="form.email"
      />
      <div v-if="form.errors.email" class="text-danger">
        {{ form.errors.email }}
      </div>
    </div>

    <div class="form-group">
      <label for="phone">
        {{ getLabel('phone') }}
      </label>
      <input
        type="tel"
        class="form-control"
        id="phone"
        :placeholder="getPlaceholder('phone')"
        v-model="form.phone"
      />
      <div v-if="form.errors.phone" class="text-danger">
        {{ form.errors.phone }}
      </div>
    </div>

    <button
      type="submit"
      :disabled="form.processing"
      class="float-right btn btn-outline-primary btn-sm"
    >
      {{ __('message_interface.btns.save') }}
    </button>
    <button
      type="button"
      :disabled="form.processing"
      class="float-right btn btn-outline-secondary btn-sm mr-2"
      @click="cancelAddNewClientContact()"
    >
      {{ __('message_interface.btns.cancel') }}
    </button>
  </form>
</template>

<script>
import { useForm } from '@inertiajs/vue3'

export default {
  props: {
    type: {
      type: String,
      required: true
    }
  },

  setup(props) {
    const form = useForm({
      type: props.type,
      first_name: null,
      last_name: null,
      email: null,
      phone: null
    })

    return {
      form
    }
  },

  emits: ['cancel', 'created'],

  methods: {
    getLabel(field) {
      return this.__('message_interface.step4.add_contact_form.' + field)
    },

    getPlaceholder(field) {
      return this.__('message_interface.step4.add_contact_form.' + field + '_placeholder')
    },

    async submitForm() {
      try {
        this.form.post('/messages/customer_contact/create', {
          preserveScroll: true,
          onSuccess: () => {
            this.form.reset('first_name', 'last_name', 'email', 'phone')
            this.$emit('created')
          }
        })
      } catch (error) {
        console.error(error)
      }
    },

    cancelAddNewClientContact() {
      this.$emit('cancel')
    }
  }
}
</script>
